// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__z2eYz","size-sm":"Toggle_size-sm__6wHvq","size-md":"Toggle_size-md__RpYof","size-lg":"Toggle_size-lg__jXCU1"};